import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {roleList, roleStatus} from '../../../redux/actions/siteActions';
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import moment from "moment";
import AffiliateDashboard from "../../affiliate/dashboard";
import {
  renderAlert,
  clearAlert
} from "../../../redux/actions/alertsActions";
import Dialog from "react-bootstrap-dialog";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util";
import Toggle from "react-bootstrap-toggle";

const history = createBrowserHistory();
let isLoading = "false";
class RoleList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_ROLE',
      roleList: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      legal_nameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      account_nameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      emailSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      deal_citySortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      registeredOnSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      path: ["Home", "Manage Role List"],
      links: ["home", "role-list"],
      show: false,
      direction: "",
      orderBy: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(limit) {
    this.setState({
      limit: limit
    });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search
    };

    this.props.roleList(postData);
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    let postData;
    if (e.target.value.length > 1) {
      postData = {
        page: "1",
        limit: this.state.limit,
        search: searchstring
      };
    }else{
      postData = {
        page: "1",
        limit: this.state.limit,
      };
    }

    if (this.state.search.length !== 0) {
      this.props.roleList(postData);
    } else {
      this.props.roleList({ page: this.state.currentPage,limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.roleList({ orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.roleList(postData);
  };

  componentWillMount() {
    isLoading = "true";
    this.handleDismiss();
    this.props.clearAlert();
    this.props.roleList({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.role !== nextProps.role) {
      if (nextProps.role) {
        const setPageCount =
          nextProps.role.data.total / nextProps.role.data.per_page;
        this.setState({
          roleList: nextProps.role.data.data,
          totalRecords: nextProps.role.data.total,
          perPage: nextProps.role.data.per_page,
          pageCount: setPageCount
        });
        isLoading = "false";
      }
    }

    if (this.props.rstatus !== nextProps.rstatus) {
      if (!isEmpty(nextProps.rstatus)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.rstatus.message);
        isLoading = "false";
        this.props.roleList({ page: this.state.currentPage,limit: this.state.limit });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleClickDelete = (e, id) => {
    this.dialog.show({
      body: "Are you sure you want to delete this role?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDeleteStatus(e, id);
          this.handleShow();
        })
      ]
    });
  };

  confirmDeleteStatus = (e, id) => {
    isLoading = "true";
    this.props.roleStatus({
      userTypeID: id,
      role_status: 'deleted',
    });
  };

  handleClick = (e, id, roleStatus) => {
    this.dialog.show({
      body: "Are you sure you want to change role status?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmStatus(e, id, roleStatus);
          this.handleShow();
        })
      ]
    });
  };

  confirmStatus = (e, id, roleStatus) => {
    isLoading = "true";
    if(roleStatus === 'modifiable'){
      this.props.roleStatus({
        userTypeID: id,
        role_status: 'inactive',
      });
    }else{
      this.props.roleStatus({
        userTypeID: id,
        role_status: 'modifiable',
      });
    }
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let roleRow;
    let roleListData = this.state.roleList
      ? this.state.roleList
      : [];
    if (!isEmpty(roleListData)) {
      roleRow = roleListData.map((role, index) => (
        <tr key={role.userTypeID}>
          <td>{role.userTypeName}</td>
          <td>{role.userTypeLabel}</td>
          <td>{role.userTypeDesc}</td>
          <td>
            <Toggle
              on={"Active"}
              off={"Inactive"}
              size="lg"
              responsive="true"
              offstyle="default"
              onstyle="success"
              height="30px"
              width="100px"
              active={(role.role_status === 'modifiable') ? true : false}
              onClick={e => {
                this.handleClick(e, role.userTypeID, role.role_status);
              }}
            />
          </td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_ROLE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/edit-role/${role.userTypeID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_ROLE') ? (<MenuItem eventKey={Math.random()} onClick={e =>{this.handleClickDelete(e, role.userTypeID)}}><i className="glyphicon glyphicon-pencil"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }else{
      roleRow = <tr><td colSpan='5'>Data Not Found</td></tr>
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Role List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  {aclUtil.checkACL('ADD_ROLE') ? (
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/add-role")}
                    >
                      + Add Role
                    </Button>)
                    : ("")}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>
                          User Type Name{" "}
                        </th>
                        <th>
                          User Type Label
                        </th>
                        <th>User Type Description</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{roleRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RoleList.propTypes = {
  roleList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  role: state.siteReducer.role,
  rstatus: state.siteReducer.rstatus,
  error: state.siteReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  roleList,
  roleStatus,
  renderAlert,
  clearAlert
})(RoleList);



// WEBPACK FOOTER //
// ./src/app/views/admin/role/RoleList.js